import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MobileMenuRoutingModule } from './mobile-menu-routing.module';

@NgModule({
    imports: [CommonModule, RouterModule, MobileMenuRoutingModule],
})
export class MobileMenuModule {}
